<template>
      <p>{{ getDepartment(params.value) == null ? 'None' : getDepartment(params.value).departmentName}}</p>
  
</template>

<script>
export default {
  name: 'CellRendererDepartment',
  created(){
    // this.$store.dispatch('lookup/getAllDepartment').catch(err => { console.error(err) })
        
  },
  computed: {
    
    getDepartment() {
      return (id) => this.$store.getters['lookup/department'](id)
        
    }
  },
//  created(){
//    this.$store.dispatch('hrms/getAllDepartment').catch(err => { console.error(err) })
//  }

}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
